import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment.prod';
import {NGXLogger} from 'ngx-logger';
import { TokenAuth0 } from '../models/tokenAuth0.model';
import { ThisReceiver } from '@angular/compiler';
import { Progetto } from '../models/progetto.model';
import { W } from 'chart.js/dist/chunks/helpers.core';
import { Utente } from '../models/utente.model';
import { UtenteDTO } from '../models/utente.dto.model';
import { ProgettoDTO } from '../models/progetto.dto.model';
import { StatsDTO } from '../models/stats.dto.model';
import { SettimanaConsegnaDTO } from '../models/progetto.settimanaConsegna.dto.models';
import { ProgettoReworked } from '../models/progettoReworked.models';
import { MessagingDTO } from '../models/messaging.dto.model';
import { ApplicationVersionDTO } from '../models/applicationVersion.result.dto.model';

@Injectable({
  providedIn: 'root',
})
export class ApplicationVersionsService{
  apiUrl: string = `${environment.apiUrl}/applicationVersion`;

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}

    getCurrentVersion(): Observable<ApplicationVersionDTO> {
      this.apiUrl =`${environment.apiUrl}/applicationVersion`;
     
      //const tokenX = localStorage.getItem("BEtoken");
      const headers = {
       // 'Authorization': `Bearer ${tokenX}`,
      };
      return this.http.get(this.apiUrl).pipe(
        tap((res: any) => {
          //this.logger.info(res);
          return res;
        }),
        catchError(this.handleError<any[]>('getProgetti', []))
      ) ;
    }

    advanceVersion(isMinor:boolean): Observable<any> {
      this.apiUrl =`${environment.apiUrl}/applicationVersion/advance/`+isMinor;

      const messaggingBody:MessagingDTO = new MessagingDTO();
      //const tokenX = localStorage.getItem("BEtoken");
      const headers = {
       // 'Authorization': `Bearer ${tokenX}`,
      };
      const httpOptions = {
          headers,
          reportProgress: true,
        };
      return this.http.post(this.apiUrl, messaggingBody, httpOptions).pipe(
          tap((res: any) => {
            return res;
          }),
          catchError(this.handleError<any[]>('advanceVersion', []))
        );
    }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
   private handleError = <T>(operation = 'applicationVersion', result?: T) => {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);
      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };
}
